export const name = 'payment-method-card';

export const PaymentMethodCard = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.98999 20.0211L11.5075 2.97363"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M1.06006 18.2587L7.18006 1.45874L18.9401 5.74124L12.8276 22.5412L1.06006 18.2587Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
